<template>

    <Transition name="pipeline-overlay">
  
      <div
        v-if="show"
        class="pipeline-overlay-backdrop"
      >
  
        <div
          class="pipeline-overlay-card"
          role="dialog"
          aria-modal="true"
        >
  
          <!-- ================================================ -->
          <!-- VISUAL -->
          <!-- ================================================ -->
  
          <div
            class="pipeline-visual"
            :class="status"
          >
  
            <!-- RUNNING -->
  
            <template
              v-if="status === 'running'"
            >
  
              <div class="pipeline-orbit orbit-one">
                <span />
              </div>
  
              <div class="pipeline-orbit orbit-two">
                <span />
              </div>
  
              <div class="pipeline-core">
  
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  aria-hidden="true"
                >
  
                  <circle
                    cx="6"
                    cy="6"
                    r="2.2"
                    stroke="currentColor"
                    stroke-width="1.8"
                  />
  
                  <circle
                    cx="18"
                    cy="12"
                    r="2.2"
                    stroke="currentColor"
                    stroke-width="1.8"
                  />
  
                  <circle
                    cx="6"
                    cy="18"
                    r="2.2"
                    stroke="currentColor"
                    stroke-width="1.8"
                  />
  
                  <path
                    d="M8.3 6H11C14.6 6 14.5 12 17 12"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                  />
  
                  <path
                    d="M8.3 18H11C14.6 18 14.5 12 17 12"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linecap="round"
                  />
  
                </svg>
  
              </div>
  
            </template>
  
  
            <!-- SUCCESS -->
  
            <template
              v-else-if="status === 'success'"
            >
  
              <div class="result-icon success">
  
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M5 12.5L10 17L19 7"
                    stroke="currentColor"
                    stroke-width="2.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
  
              </div>
  
            </template>
  
  
            <!-- ERROR -->
  
            <template
              v-else-if="status === 'error'"
            >
  
              <div class="result-icon error">
                !
              </div>
  
            </template>
  
          </div>
  
  
          <!-- ================================================ -->
          <!-- TITLE -->
          <!-- ================================================ -->
  
          <div class="pipeline-heading">
  
            <span
              v-if="status === 'running'"
              class="pipeline-live"
            >
              <span class="pipeline-live-dot" />
              ОБРАБОТКА
            </span>
  
  
            <h2>
              {{ title }}
            </h2>
  
  
            <p>
              {{ subtitle }}
            </p>
  
          </div>
  
  
          <!-- ================================================ -->
          <!-- RUNNING -->
          <!-- ================================================ -->
  
          <div
            v-if="status === 'running'"
            class="pipeline-running"
          >
  
            <div class="pipeline-flow">
  
              <div class="pipeline-step">
  
                <span class="step-indicator">
                  01
                </span>
  
                <div>
                  <strong>
                    Компании
                  </strong>
  
                  <span>
                    сопоставление и проверка
                  </span>
                </div>
  
              </div>
  
  
              <div class="flow-connector">
  
                <span />
  
              </div>
  
  
              <div class="pipeline-step">
  
                <span class="step-indicator">
                  02
                </span>
  
                <div>
                  <strong>
                    Изображения
                  </strong>
  
                  <span>
                    поиск и привязка
                  </span>
                </div>
  
              </div>
  
            </div>
  
  
            <div class="pipeline-progress">
  
              <div class="pipeline-progress-glow" />
  
            </div>
  
  
            <div class="pipeline-wait-note">
  
              <span class="wait-dot" />
  
              Пайплайн выполняется на сервере.
              Результаты обновятся автоматически.
  
            </div>
  
          </div>
  
  
          <!-- ================================================ -->
          <!-- SUCCESS -->
          <!-- ================================================ -->
  
          <div
            v-else-if="status === 'success'"
            class="pipeline-result"
          >
  
            <div class="result-grid">
  
              <div class="result-stat">
  
                <span>
                  Компании
                </span>
  
                <strong>
                  {{
                    companyStats.resolved
                    ?? 0
                  }}
                </strong>
  
                <small>
                  найдено
                </small>
  
              </div>
  
  
              <div class="result-stat">
  
                <span>
                  Изображения
                </span>
  
                <strong>
                  {{
                    imageStats.resolved
                    ?? 0
                  }}
                </strong>
  
                <small>
                  найдено
                </small>
  
              </div>
  
  
              <div class="result-stat">
  
                <span>
                  Без компании
                </span>
  
                <strong>
                  {{
                    companyStats.not_found
                    ?? 0
                  }}
                </strong>
  
                <small>
                  требуют внимания
                </small>
  
              </div>
  
  
              <div class="result-stat">
  
                <span>
                  Время
                </span>
  
                <strong>
                  {{ duration }}
                </strong>
  
                <small>
                  секунд
                </small>
  
              </div>
  
            </div>
  
          </div>
  
  
          <!-- ================================================ -->
          <!-- ERROR -->
          <!-- ================================================ -->
  
          <div
            v-else-if="status === 'error'"
            class="pipeline-error"
          >
  
            {{ errorMessage }}
  
          </div>
  
  
          <!-- ================================================ -->
          <!-- FOOTER -->
          <!-- ================================================ -->
  
          <div
            v-if="status !== 'running'"
            class="pipeline-footer"
          >
  
            <button
              class="pipeline-close-button"
              @click="$emit('close')"
            >
              Готово
            </button>
  
          </div>
  
        </div>
  
      </div>
  
    </Transition>
  
  </template>
  
  
  <script setup>
  
  import {
    computed
  } from "vue";
  
  
  const props =
    defineProps({
  
      show: {
        type: Boolean,
        default: false
      },
  
      status: {
        type: String,
        default: "running"
      },
  
      result: {
        type: Object,
        default: null
      },
  
      errorMessage: {
        type: String,
        default: ""
      }
  
    });
  
  
  defineEmits([
    "close"
  ]);
  
  
  const companyStats =
    computed(
      () =>
        props.result
          ?.company_resolution
        ?? {}
    );
  
  
  const imageStats =
    computed(
      () =>
        props.result
          ?.image_resolution
        ?? {}
    );
  
  
  const duration =
    computed(
      () =>
        props.result
          ?.duration_seconds
        ?? 0
    );
  
  
  const title =
    computed(
      () => {
  
        switch (
          props.status
        ) {
  
          case "success":
            return (
              "Пайплайн завершён"
            );
  
          case "error":
            return (
              "Не удалось завершить обработку"
            );
  
          default:
            return (
              "Обрабатываем вакансии"
            );
  
        }
  
      }
    );
  
  
  const subtitle =
    computed(
      () => {
  
        switch (
          props.status
        ) {
  
          case "success":
            return (
              "Черновики обновлены и готовы к проверке."
            );
  
          case "error":
            return (
              "Во время выполнения пайплайна произошла ошибка."
            );
  
          default:
            return (
              "Сопоставляем компании и подбираем изображения."
            );
  
        }
  
      }
    );
  
  </script>
  
  
  <style scoped>
  
  .pipeline-overlay-backdrop {
    position: fixed;
    inset: 0;
  
    z-index: 20000;
  
    display: flex;
  
    padding: 24px;
  
    align-items: center;
    justify-content: center;
  
    background:
      rgba(
        8,
        8,
        12,
        0.64
      );
  
    backdrop-filter:
      blur(10px);
  }
  
  
  .pipeline-overlay-card {
    width:
      min(
        520px,
        100%
      );
  
    padding:
      32px;
  
    border:
      1px solid
      var(
        --vd-border,
        #292929
      );
  
    border-radius:
      22px;
  
    background:
      var(
        --vd-card,
        #181818
      );
  
    color:
      var(
        --vd-text,
        #f4f4f4
      );
  
    box-shadow:
      0 30px 90px
      rgba(
        0,
        0,
        0,
        0.32
      );
  }
  
  
  /* =========================================================
     VISUAL
  ========================================================= */
  
  .pipeline-visual {
    position: relative;
  
    width: 104px;
    height: 104px;
  
    margin:
      0 auto
      24px;
  }
  
  
  .pipeline-core {
    position: absolute;
  
    inset: 23px;
  
    z-index: 3;
  
    display: flex;
  
    align-items: center;
    justify-content: center;
  
    border-radius: 20px;
  
    background:
      linear-gradient(
        135deg,
        #5575f6,
        #7657eb
      );
  
    color: #ffffff;
  
    box-shadow:
      0 14px 32px
      rgba(
        91,
        92,
        230,
        0.28
      );
  }
  
  
  .pipeline-core svg {
    width: 30px;
    height: 30px;
  }
  
  
  .pipeline-orbit {
    position: absolute;
  
    border:
      1px solid
      rgba(
        109,
        105,
        245,
        0.24
      );
  
    border-radius: 50%;
  }
  
  
  .pipeline-orbit span {
    position: absolute;
  
    width: 7px;
    height: 7px;
  
    border-radius: 50%;
  
    background: #6d69f5;
  
    box-shadow:
      0 0 12px
      rgba(
        109,
        105,
        245,
        0.75
      );
  }
  
  
  .orbit-one {
    inset: 4px;
  
    animation:
      orbit-spin
      2.8s
      linear
      infinite;
  }
  
  
  .orbit-one span {
    top: -4px;
    left: 50%;
  }
  
  
  .orbit-two {
    inset: 14px;
  
    animation:
      orbit-spin
      2s
      linear
      infinite
      reverse;
  }
  
  
  .orbit-two span {
    right: -4px;
    top: 50%;
  }
  
  
  .result-icon {
    position: absolute;
    inset: 18px;
  
    display: flex;
  
    align-items: center;
    justify-content: center;
  
    border-radius: 24px;
  
    color: #ffffff;
  
    font-size: 28px;
    font-weight: 700;
  }
  
  
  .result-icon.success {
    background:
      linear-gradient(
        135deg,
        #2bad68,
        #208853
      );
  }
  
  
  .result-icon.error {
    background:
      linear-gradient(
        135deg,
        #d95b5b,
        #b43d3d
      );
  }
  
  
  .result-icon svg {
    width: 34px;
    height: 34px;
  }
  
  
  /* =========================================================
     HEADING
  ========================================================= */
  
  .pipeline-heading {
    text-align: center;
  }
  
  
  .pipeline-live {
    display: inline-flex;
  
    margin-bottom: 9px;
  
    align-items: center;
  
    gap: 6px;
  
    color:
      var(
        --vd-muted,
        #767676
      );
  
    font-size: 9px;
    font-weight: 700;
  
    letter-spacing:
      0.12em;
  }
  
  
  .pipeline-live-dot {
    width: 6px;
    height: 6px;
  
    border-radius: 50%;
  
    background: #686bf1;
  
    box-shadow:
      0 0 0 4px
      rgba(
        104,
        107,
        241,
        0.10
      );
  
    animation:
      live-pulse
      1.5s
      ease-in-out
      infinite;
  }
  
  
  .pipeline-heading h2 {
    margin: 0;
  
    font-size: 21px;
    font-weight: 680;
  
    letter-spacing:
      -0.025em;
  }
  
  
  .pipeline-heading p {
    max-width: 390px;
  
    margin:
      8px auto
      0;
  
    color:
      var(
        --vd-muted,
        #767676
      );
  
    font-size: 11px;
    line-height: 1.55;
  }
  
  
  /* =========================================================
     FLOW
  ========================================================= */
  
  .pipeline-running {
    margin-top: 28px;
  }
  
  
  .pipeline-flow {
    display: grid;
  
    grid-template-columns:
      1fr
      42px
      1fr;
  
    align-items: center;
  }
  
  
  .pipeline-step {
    display: flex;
  
    min-width: 0;
  
    padding: 12px;
  
    align-items: center;
  
    gap: 10px;
  
    border:
      1px solid
      var(
        --vd-border,
        #292929
      );
  
    border-radius: 13px;
  
    background:
      var(
        --vd-soft,
        #202020
      );
  }
  
  
  .step-indicator {
    display: flex;
  
    width: 28px;
    height: 28px;
  
    flex-shrink: 0;
  
    align-items: center;
    justify-content: center;
  
    border-radius: 9px;
  
    background:
      rgba(
        100,
        101,
        240,
        0.12
      );
  
    color: #7778f4;
  
    font-size: 9px;
    font-weight: 700;
  }
  
  
  .pipeline-step div {
    display: flex;
  
    min-width: 0;
  
    flex-direction: column;
  
    gap: 2px;
  }
  
  
  .pipeline-step strong {
    font-size: 10px;
    font-weight: 650;
  }
  
  
  .pipeline-step div span {
    color:
      var(
        --vd-muted,
        #767676
      );
  
    font-size: 9px;
  }
  
  
  .flow-connector {
    position: relative;
  
    height: 1px;
  
    overflow: hidden;
  
    background:
      var(
        --vd-border,
        #292929
      );
  }
  
  
  .flow-connector span {
    position: absolute;
  
    top: 0;
    bottom: 0;
  
    width: 16px;
  
    background:
      linear-gradient(
        90deg,
        transparent,
        #7172f4,
        transparent
      );
  
    animation:
      connector-move
      1.4s
      ease-in-out
      infinite;
  }
  
  
  /* =========================================================
     INDETERMINATE PROGRESS
  ========================================================= */
  
  .pipeline-progress {
    position: relative;
  
    height: 4px;
  
    margin-top: 22px;
  
    overflow: hidden;
  
    border-radius: 99px;
  
    background:
      var(
        --vd-soft,
        #202020
      );
  }
  
  
  .pipeline-progress-glow {
    position: absolute;
  
    top: 0;
    bottom: 0;
  
    width: 34%;
  
    border-radius: inherit;
  
    background:
      linear-gradient(
        90deg,
        transparent,
        #6769ef,
        #8c68ec,
        transparent
      );
  
    animation:
      progress-move
      1.65s
      ease-in-out
      infinite;
  }
  
  
  .pipeline-wait-note {
    display: flex;
  
    margin-top: 14px;
  
    align-items: center;
    justify-content: center;
  
    gap: 7px;
  
    color:
      var(
        --vd-muted,
        #767676
      );
  
    font-size: 9px;
  }
  
  
  .wait-dot {
    width: 5px;
    height: 5px;
  
    border-radius: 50%;
  
    background: #6d6ff2;
  }
  
  
  /* =========================================================
     RESULT
  ========================================================= */
  
  .pipeline-result {
    margin-top: 26px;
  }
  
  
  .result-grid {
    display: grid;
  
    grid-template-columns:
      repeat(
        4,
        minmax(
          0,
          1fr
        )
      );
  
    gap: 8px;
  }
  
  
  .result-stat {
    display: flex;
  
    min-width: 0;
  
    padding:
      12px
      9px;
  
    flex-direction: column;
  
    align-items: center;
  
    border:
      1px solid
      var(
        --vd-border,
        #292929
      );
  
    border-radius: 12px;
  
    background:
      var(
        --vd-soft,
        #202020
      );
  
    text-align: center;
  }
  
  
  .result-stat span {
    color:
      var(
        --vd-muted,
        #767676
      );
  
    font-size: 8px;
  }
  
  
  .result-stat strong {
    margin:
      5px 0
      2px;
  
    font-size: 20px;
    font-weight: 680;
  }
  
  
  .result-stat small {
    color:
      var(
        --vd-muted,
        #767676
      );
  
    font-size: 7px;
  }
  
  
  /* =========================================================
     ERROR
  ========================================================= */
  
  .pipeline-error {
    margin-top: 24px;
  
    padding: 13px;
  
    border:
      1px solid
      rgba(
        211,
        75,
        75,
        0.20
      );
  
    border-radius: 12px;
  
    background:
      rgba(
        211,
        75,
        75,
        0.07
      );
  
    color: #d76868;
  
    font-size: 10px;
    line-height: 1.5;
  
    text-align: center;
  }
  
  
  /* =========================================================
     FOOTER
  ========================================================= */
  
  .pipeline-footer {
    display: flex;
  
    margin-top: 24px;
  
    justify-content: center;
  }
  
  
  .pipeline-close-button {
    min-width: 120px;
  
    height: 38px;
  
    padding:
      0
      18px;
  
    border: 0;
    border-radius: 10px;
  
    background:
      linear-gradient(
        135deg,
        #5575f6,
        #7657eb
      );
  
    color: #ffffff;
  
    cursor: pointer;
  
    font-size: 10px;
    font-weight: 600;
  }
  
  
  /* =========================================================
     TRANSITION
  ========================================================= */
  
  .pipeline-overlay-enter-active,
  .pipeline-overlay-leave-active {
    transition:
      opacity 0.2s ease;
  }
  
  
  .pipeline-overlay-enter-active
  .pipeline-overlay-card,
  .pipeline-overlay-leave-active
  .pipeline-overlay-card {
    transition:
      transform 0.24s ease,
      opacity 0.2s ease;
  }
  
  
  .pipeline-overlay-enter-from,
  .pipeline-overlay-leave-to {
    opacity: 0;
  }
  
  
  .pipeline-overlay-enter-from
  .pipeline-overlay-card {
    opacity: 0;
  
    transform:
      translateY(12px)
      scale(0.98);
  }
  
  
  .pipeline-overlay-leave-to
  .pipeline-overlay-card {
    opacity: 0;
  
    transform:
      translateY(8px)
      scale(0.985);
  }
  
  
  /* =========================================================
     ANIMATIONS
  ========================================================= */
  
  @keyframes orbit-spin {
  
    to {
      transform:
        rotate(360deg);
    }
  
  }
  
  
  @keyframes live-pulse {
  
    0%,
    100% {
      opacity: 0.55;
    }
  
    50% {
      opacity: 1;
    }
  
  }
  
  
  @keyframes connector-move {
  
    from {
      left: -30%;
    }
  
    to {
      left: 110%;
    }
  
  }
  
  
  @keyframes progress-move {
  
    0% {
      left: -40%;
    }
  
    100% {
      left: 110%;
    }
  
  }
  
  
  /* =========================================================
     MOBILE
  ========================================================= */
  
  @media (max-width: 560px) {
  
    .pipeline-overlay-backdrop {
      padding: 14px;
    }
  
  
    .pipeline-overlay-card {
      padding:
        26px
        18px;
    }
  
  
    .pipeline-flow {
      grid-template-columns: 1fr;
      gap: 8px;
    }
  
  
    .flow-connector {
      width: 1px;
      height: 18px;
  
      margin: 0 auto;
    }
  
  
    .result-grid {
      grid-template-columns:
        repeat(
          2,
          minmax(
            0,
            1fr
          )
        );
    }
  
  }
  
  </style>